document.addEventListener("DOMContentLoaded", setLoggedInClasses)

function setLoggedInClasses() {
  const loggedInClasses = document.getElementById("metaDescription").dataset.loggedInClasses
  document.body.classList.remove("app-logged-in", "logged-in-user", "logged-in-player")
  if (loggedInClasses.length > 0) { document.body.classList.add(...loggedInClasses.split(" ")) }
}
